

// 目次

  {
    const TOC_INSERT_SELECTOR = '.toc';     // [セレクター指定] 目次を挿入する要素 querySelector用
    const HEADING_SELECTOR    = '.toc-heading'; // [セレクター指定] 収集する見出し要素 querySelectorAll用
    const LINK_CLASS_NAME     = 'tocLink';  // [クラス名] 目次用aタグに追加するクラス名
    const ID_NAME             = 'toc-heading';  // [ID名]    目次に追加するID名のプレフィックス #無し
    const tocInsertElements  = document.querySelector(TOC_INSERT_SELECTOR);
    const headingElements    = document.querySelectorAll(HEADING_SELECTOR);
    const layer = [];
    let id = 0;
    const uid   = () =>`${ID_NAME}${id++}`;
    let links = null;
    let oldRank = -1;
    try {
      const createLink = (el) => {
        let li = document.createElement('li');
        let a  = document.createElement('a');
        el.id  = el.id || uid();
        a.href = `#${el.id}`;
        a.innerText = el.innerText;
        a.className = LINK_CLASS_NAME;
        li.appendChild(a);
        return li;
      };
      const findParentElement = (layer, rank, diff) => {
        do {
          rank += diff;
          if (layer[rank]) return layer[rank];
        } while (0 < rank && rank < 7);
        return false;
      };
      const appendToc = (el, toc) => {
        el.appendChild(toc.cloneNode(true));
      };
      const focus = (e) => {
        const sy = window.pageYOffset;
        const ey = sy + document.documentElement.clientHeight;
        let focusEl = null;
        links.forEach( (el) => {
          const targetEl = document.querySelector(el.hash);
          const y = sy + targetEl.getBoundingClientRect().top ;
          el.classList.remove("active") ;
          if(sy < y &&  y < ey)focusEl = el;
          if(sy > y) focusEl = el;
        });
        if(focusEl)focusEl.classList.add("active");
      };
      headingElements.forEach( (el) => {
        let rank   = Number(el.tagName.substring(1));
        let parent = findParentElement(layer, rank, -1);
        if (oldRank > rank) layer.length = rank + 1;
        if (!layer[rank]) {
          layer[rank] = document.createElement('ul');
          if (parent.lastChild) parent.lastChild.appendChild(layer[rank]);
        }
        layer[rank].appendChild(createLink(el));
        oldRank = rank;
      });
      if (layer.length) appendToc(tocInsertElements, findParentElement(layer, 0, 1));
      links = document.querySelectorAll(`.${LINK_CLASS_NAME}`);
      links.forEach((el) => {
        el.addEventListener("click",(e)=>{
          const targetEl = document.querySelector(el.hash);
          scrollTo(0, window.pageYOffset + targetEl.getBoundingClientRect().top - 150);
          e.preventDefault();
          e.stopPropagation();
          return false;
        });
      });
      focus();
      window.addEventListener("scroll", focus);
    } catch (e) {
      //error 
    }
  }





// 機能モーダルウィンドウ

  const modalWrapOpen = function(e) {
    const dataModalOpen = e.currentTarget.dataset.modalOpen;
    Array.from(document.querySelectorAll('.card_modal_wrapper')).forEach((e, i) => {
      if(e.getAttribute('data-modal') === dataModalOpen){
        e.classList.toggle('is_open');
      }
    })
  }

  Array.from(document.querySelectorAll('.modal_open')).forEach((modalOpenElement) => {
    modalOpenElement.addEventListener('click', modalWrapOpen);
  })

  const modalCloseAction = function(e) {
    const targetModal = e.currentTarget.closest('.card_modal_wrapper');
    targetModal.classList.toggle('is_open')
  };

  Array.from(document.querySelectorAll('.card_modal_close')).forEach((modalCloseElement) => {
    modalCloseElement.addEventListener('click', modalCloseAction)
  })


  Array.from(document.querySelectorAll('.card_modal_mask')).forEach((modalCloseElement) => {
    modalCloseElement.addEventListener('click', modalCloseAction)
  })  

  
  
  
  
  window.addEventListener('DOMContentLoaded', function(){

    document.getElementById('toc-sidebar').style.visibility = 'hidden';

    document.getElementById('toc-sidebar').addEventListener('transitionend', function(){

      if( document.getElementById('toc-sidebar').className !== 'view' ) {
        document.getElementById('toc-sidebar').style.visibility = 'hidden';
      }
    });

    window.addEventListener('scroll', function(){
      if( 180 < window.scrollY ) {
        document.getElementById('toc-sidebar').style.visibility = 'visible';
        document.getElementById('toc-sidebar').classList.add('view');

      } else {
        document.getElementById('toc-sidebar').classList.remove('view');
      }
    });
  });


